module.exports = __webpack_public_path__ + "img/task_ureply.8472f885.png";